import InfiniteScroll from 'react-infinite-scroll-component';

export default InfiniteScroll;
